export const ErrorOutline = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
<path d="M22.2332 22.2332L9.79202 9.79199" stroke="currentColor" stroke-width="2"/>
</svg>`;
